import { useCallback, useEffect, useState } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { ActionButton, Confirm } from "@/shared/ui";
import { activeKeySelector, setActiveKey } from "@/domains/activeKey/slice";
import useExit from "@/domains/auth/hooks/useExit";
import KeyCode from "@/assets/constants/key-code";

export default function AuthNavigationContainer() {
  const { exit, isPending } = useExit();
  const activeKey = useAppSelector(activeKeySelector);
  const dispatch = useAppDispatch();
  const [showConfirmExit, setShowConfirmExit] = useState(false);

  const openConfirmExit = useCallback(() => {
    setShowConfirmExit(true);
  }, []);

  const closeConfirmExit = useCallback(() => {
    setShowConfirmExit(false);
  }, []);

  const handleKeyDown = useCallback(
    async (e: KeyboardEvent) => {
      if (e.repeat) return;

      if ([KeyCode.ESCAPE].includes(e.keyCode)) {
        e.preventDefault();
        dispatch(setActiveKey(e.keyCode));
        switch (e.keyCode) {
          case KeyCode.ESCAPE: {
            openConfirmExit();

            break;
          }
          default:
            break;
        }
      }
    },
    [dispatch, exit],
  );

  const handleKeyUp = useCallback(() => {
    dispatch(setActiveKey());
  }, [dispatch]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyDown, handleKeyUp]);

  return (
    <>
      <Confirm
        onCancel={closeConfirmExit}
        onConfirm={exit}
        pending={isPending}
        open={showConfirmExit}
      >
        <div className="w-full text-center text-16 font-bold text-white">
          Желаете выйти из игры?
        </div>
      </Confirm>
      <div className="fixed bottom-[--boundary-offset-y] left-[50%] -translate-x-[50%]">
        <ActionButton
          isActive={activeKey === KeyCode.ESCAPE}
          action="ESC"
          label="Выйти из игры"
          key={KeyCode.ESCAPE}
          onClick={openConfirmExit}
        />
      </div>
    </>
  );
}
